import React, { useEffect, useState } from "react";
import Text from "../../../../components/ui/Text";

interface SlideInputProps {
  value?: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  step?: number;
  showPercentage?: boolean;
  className?: string;
}

const SlideInput: React.FC<SlideInputProps> = ({
  value: valueFromProps,
  onChange: onChangeFromProps,
  min = 0,
  max = 100,
  step = 1,
  showPercentage = true,
  className = "",
}) => {
  const [value, setValue] = useState<number>();

  useEffect(() => {
    if (valueFromProps) {
      setValue(valueFromProps);
    }
  }, [valueFromProps]);

  function onChange(newValue: number) {
    setValue(newValue);
    onChangeFromProps(newValue);
  }

  return (
    <div
      className={`flex items-center  bg-gradient-to-r from-[#2f3458] to-[#34385d]
 rounded-md ${className}`}
    >
      {/* Slider */}
      <div className="h-[40px] flex justify-center items-center px-2 w-full">
        <input
          type="range"
          min={min}
          max={max}
          step={step}
          value={value}
          onChange={(e) => onChange(Number(e.target.value))}
          className="
          w-full h-1 rounded-lg appearance-none cursor-pointer mt-[1px]
          bg-gradient-to-r from-[#BEB9FF] to-indigo-400
        "
          style={{
            accentColor: "white", // fallback for browsers that support accent-color
          }}
        />
      </div>
      {/* Percentage Box */}
      {showPercentage && (
        <div className="bg-[#3b427a] p-2 w-full max-w-[27%] text-center rounded-r-md">
          <Text
            size="xs"
            className="text-[#BEB9FF] flex gap-[1px] text-center justify-center items-center"
          >
            {value} <span className="font-sans">%</span>
          </Text>
        </div>
      )}
    </div>
  );
};

export default SlideInput;
